$mol_touch $mol_plugin
	start_zoom? 0
	start_distance? 0
	zoom? 1
	allow_draw true
	allow_pan true
	allow_zoom true
	action_type? \
	action_point? $mol_vector_2d<number> /
		NaN
		NaN
	-
	start_pan? /
		0
		0
	pan? $mol_vector_2d<number> /
		0
		0
	pointer_center $mol_vector_2d<number> /
		NaN
		NaN
	-
	start_pos? null
	swipe_precision 16
	-
	swipe_right? null
	swipe_bottom? null
	swipe_left? null
	swipe_top? null
	-
	swipe_from_right? null
	swipe_from_bottom? null
	swipe_from_left? null
	swipe_from_top? null
	-
	swipe_to_right? null
	swipe_to_bottom? null
	swipe_to_left? null
	swipe_to_top? null
	-
	draw_start? null
	draw? null
	draw_end? null
	-
	style *
		^
		touch-action \none
		overscroll-behavior \none
	-
	event *
		^
		pointerdown? <=> event_start? null
		pointermove? <=> event_move? null
		pointerup? <=> event_end? null
		pointerleave? <=> event_leave? null
		wheel? <=> event_wheel? null
